import React from 'react';
import { ThemeContext } from '../theme/Theme.jsx'


function ZigZagBoxHeadline(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('zig-zag-box-headline', 'fontSize', 'font-size-250'),
		fontWeight: '600',
		padding: '0 0 0.4em 0',
		margin: '0 0 1em 0',
		textTransform: 'uppercase',
		textAlign: 'center',
	};
	const Headline = props.headlineLevel? props.headlineLevel : 'h1';
	return (
		<Headline style={style}>
			{props.children}
		</Headline>
	);
}

export default ZigZagBoxHeadline;
